import styled from 'styled-components';

export const ModalText = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  padding: 12px 24px 0;
  span {
    font-weight: 700;
    color: ${({ theme }) => theme.colors.main};
  }
  p {
    margin: 15px 0;
  }
  p.reason {
    color: ${({ theme }) => theme.colors.main};
  }
  p.response {
    font-size: 12px;
    font-family: ${({ theme }) => theme.fonts.secondary};
    color: ${({ theme }) => theme.colors.textLight};
  }
`;

export const ButtonFooter = styled.div`
  width: fit-content;
  margin: 30px auto 0;
  display: flex;
  gap: 13px;
`;
